module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAqElEQVR4AWOgD5hxmEhENw0PGExespiDEIPRGwWfz3Uz3vsVvmS3fMmgBxSEI6AyhIZXLOavmExf8Vj92nvqY2TVKy6zt5qh7ywTQeLM5iASXQPIeMO3OhG/z1x/yaD/kkH724y1fx69eM1n+4oJbBxWG17zWP/ad/pjWMUrTtO32mHvbZJfsZgBpeAaMP1g+EbJ70vjrA9+ha/w+IFhXSqRiA4aBiUAAHFywlsFajR0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AZ.png
// module id = 1083
// module chunks = 0